module.exports = __webpack_public_path__ + "img/cloudClincIconA.b17f04b8.svg";